import React,{useState} from "react";
// import axios from "../../../../../../../axios"
import "./active.css";

const DeleteConfirmation =({
  errorText,
  onConfirm,
  onCancel
}) => {
  console.log(errorText)
  return (
    <div className="published_Deative_transprant_body">
      <div className="published_Deative_preview_container">
        <img
          className="deactive_closeBtn"
          src="/images/cross-circle3.svg"
          alt=""
          onClick={(e) => onCancel()}
        />
        <div className="col-12 deactivate_msg">
          Are you sure you want to delete this homework?
          {errorText && <p style={{ color: "red" }}>{errorText}</p>}
        </div>
        <div className="row col-12 publish_deactive_btnBox">
          <button
            onClick={onConfirm}
            className="btn col-sm-5 my-1 deactive_sure_btn"
          >
            Yes
          </button>
          <button
            className="btn col-sm-5 my-1 deactive_sure_btn"
            onClick={(e) => onCancel()}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;
